<template>
  <div v-if="orgData">
    <div class="alert" :class="`alert-${alertStatus}`" v-if="alertMessage" v-text="alertMessage"></div>
    <div class="form-group">
      <label>Organization Name:</label>
      <input class="form-control" name="name" v-model="orgData.name"/>
    </div>
    <button class="btn btn-success btn-block" @click="saveData">Save</button>
  </div>
</template>

<style scoped lang="scss">
  .form-group {
    label {
      font-weight: bold;
    }
  }
</style>

<script>
export default {
  props: {
    org: Object
  },
  data() {
    return {
      alertStatus: "success",
      alertMessage: "",
      orgData: {
        name: ""
      }
    };
  },
  watch: {
    org(value) {
      if (!this.org.allowedToEdit) {
        this.$router.replace("/403");
      }
      this.orgData = Object.assign({}, value);
    }
  },
  methods: {
    async saveData() {
      try {
        await this.axios.put(`/organizations/${this.org.slug}`, this.orgData);
        this.$emit("readData");
        this.alertStatus = "success";
        this.alertMessage = "Data stored";
      } catch (e) {
        this.alertStatus = "danger";
        this.alertMessage = e.message;
      } finally {
        setTimeout(() => {
          this.alertMessage = "";
        }, 2500);
      }
    }
  },
  beforeMount() {
    this.orgData = Object.assign({}, this.org);
  }
};
</script>
